import { render, staticRenderFns } from "./MigrationForm.vue?vue&type=template&id=62131bb5"
import script from "./MigrationForm.vue?vue&type=script&lang=ts"
export * from "./MigrationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports